export default __webpack_public_path__ + "static/media/brain.d5777938.svg";